<ng-form #form>
	<div class="p-grid mt-1">
		<div class="p-col-12 p-md-6" *ngIf="displayFirstName">
			<span class="p-float-label mt-3">
				<input
					pInputText
					#firstNameInput
					autocomplete="cc-given-name"
					name="firstNameInput"
					type="text"
					[(ngModel)]="firstName"
					(ngModelChange)="firstNameChange.emit(firstName)"
					class="w-100"
					required
					NoWhitespaceValidator
				/>
				<label for="firstNameInput">First Name</label>
			</span>
		</div>
		<div class="p-col-12 p-md-6" *ngIf="displayLastName">
			<span class="p-float-label mt-3">
				<input
					pInputText
					#lastNameInput
					autocomplete="cc-family-name"
					name="lastNameInput"
					type="text"
					[(ngModel)]="lastName"
					(ngModelChange)="lastNameChange.emit(lastName)"
					class="w-100"
					required
					NoWhitespaceValidator
				/>
				<label for="lastNameInput">Last Name</label>
			</span>
		</div>
	</div>
	<div class="p-grid mt-1">
		<div class="p-col-12 p-md-6" *ngIf="displayPhone">
			<span class="p-float-label mt-3">
				<input
					pInputText
					#phoneInput
					name="phoneInput"
					type="tel"
					autocomplete="tel"
					required
					[(ngModel)]="phone"
					(ngModelChange)="phoneChange.emit(phone)"
					class="w-100"
					phone="US"
					mask="(000) 000-0000"
				/>
				<label for="phoneInput">Phone Number</label>
			</span>
		</div>
		<div class="p-col-12 p-md-6" *ngIf="displayEmail">
			<span class="p-float-label mt-3">
				<input
					pInputText
					#emailInput
					name="emailInput"
					[(ngModel)]="email"
					(ngModelChange)="emailChange.emit(email)"
					class="w-100"
					required
					email
					autocorrect="email"
					type="email"
				/>
				<label for="emailInput">Email</label>
			</span>
		</div>
	</div>
	<div class="p-grid mt-3">
		<div class="p-col-12" *ngIf="displayAddress">
			<address-selection-input
				(autoCompleteInputChange)="addressChange.emit($event)"
				(selectAddress)="addressChange.emit($event)"
				[placeholder]="addressPlaceholder"
				addressType="geocode"
				source="subscriptionCheckoutPurchaserForm"
			></address-selection-input>
		</div>
	</div>
	<div class="footer">
		<div class="submit-button" *ngIf="displayButton">
			<p-button pRipple [styleClass]="buttonClass" [disabled]="form.invalid" (click)="formComplete.emit()">
				<ng-template pTemplate="content">
					<div class="flex justify-content-center">{{ buttonText }}</div>
				</ng-template>
			</p-button>
		</div>
	</div>
</ng-form>
